import React from 'react'
import './style.css'
import PricingCards from './PricingCards'
import PricingDetails from '../../consts/PricingDetails'

const Pricing = () => {
  return (
    <div id="pricingSection" className="pricing-layout">

<br/>
<br/>
<br/>
<br/>
<br/>

    <div className="pricing-container">
    <div className="pricing-subsection">
        <div className="pricing-container-title">Pricing</div>
        <br/>
        <br/>
        


        <div className="pricing-cards-container">
        {PricingDetails.map((detail, index) => (
        <PricingCards key={index} packageDetails={detail} purchaseRequired={false}/>
      ))}

        </div></div>
    </div>
    
</div>

    
  )
}

export default Pricing